import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { EventDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

interface UpdateEventParams {
  eventId: number;
  reservationRequestIds?: number[];
  restaurantId?: number | null;
  afterPartyVenueId?: number | null;
}

const updateEvent = async ({
  eventId,
  reservationRequestIds,
  restaurantId,
  afterPartyVenueId,
}: UpdateEventParams): Promise<EventDto> => {
  const response = await apiFetch(`api/admin/events/${eventId}`, {
    method: "PATCH",
    body: JSON.stringify({ reservationRequestIds, restaurantId, afterPartyVenueId }),
  });

  if (!response.ok) {
    throw new Error(await getApiErrorMessage(response));
  }

  return response.json();
};

export const useUpdateEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEvent,
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ["events"] }),
        queryClient.invalidateQueries({ queryKey: ["reservation-requests"] }),
      ]),
  });
};
